import ResponseMetaInformation_vue_vue_type_script_setup_true_lang_default from "./ResponseMetaInformation.vue.script.js";
//#region src/v2/blocks/response-block/components/ResponseMetaInformation.vue
var ResponseMetaInformation_default = ResponseMetaInformation_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ResponseMetaInformation_default as default };

//# sourceMappingURL=ResponseMetaInformation.vue.js.map